import styled from 'styled-components';
import { Box } from '@usealloy/component-library';

export const StyledSpinnerContainer = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  pointer-events: none;
`;
